import { State } from "@features/base/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  AdminWithdrawalsResponse,
  AdminWithdrawalsRequest,
  getAdminWithdrawalsApi,
  AdminWithdrawal,
  AdminWithdrawalUpdateRequest,
  updateAdminWithdrawalApi,
} from "./api";

export const getAdminWithdrawals = createAsyncThunk<
  AdminWithdrawalsResponse,
  { data?: AdminWithdrawalsRequest }
>(
  "adminWithdrawals/getAdminWithdrawals",
  async ({ data }, { rejectWithValue }) => {
    try {
      return await getAdminWithdrawalsApi(data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateAdminWithdrawal = createAsyncThunk<
  string,
  { withdrawalId: string, data: AdminWithdrawalUpdateRequest }
>(
  "adminWithdrawals/updateAdminWithdrawals",
  async ({ withdrawalId, data }, { rejectWithValue }) => {
    try {
      return await updateAdminWithdrawalApi(withdrawalId, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

type AdminWithdrawalsState = State<{
  withdrawals: AdminWithdrawal[] | null;
  page: number,
  limit: number,
  count: number,
}>;

const initialState: AdminWithdrawalsState = {
  withdrawals: null,
  loading: false,
  error: null,
  page: 1,
  limit: 10,
  count: 0
};

const adminWithdrawalsSlice = createSlice({
  name: "adminWithdrawals",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdminWithdrawals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdminWithdrawals.fulfilled, (state, action) => {
        state.loading = false;
        state.withdrawals = action.payload.withdrawals;
        state.page = action.payload.page;
        state.count = action.payload.count;
      })
      .addCase(getAdminWithdrawals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateAdminWithdrawal.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
      })
      .addCase(updateAdminWithdrawal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default adminWithdrawalsSlice.reducer;
